<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/rheinhessen')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/germany/rheinhessen/klaus-peter-keller')">Klaus-Peter Keller
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/rheinhessen/von-buhl')">Von Buhl
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/germany/rheinhessen')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Klaus-Peter Keller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Il completo rilancio dell'industria vinicola tedesca può, forse, essere attribuito a una manciata di
                        produttori. Ma Klaus-Peter Keller, che ha rilevato l'azienda vinicola di famiglia nel 2001, è stato più
                        influente della maggior parte.
                    </div>

                    <div class="howto-title2">Tale padre, tale figlio</div>
                    <div class="howto-text">
                        Non estraneo ai campi, Klaus-Peter è solo l'ultimo di una lunga serie di Keller maschi che l'hanno fatto
                        al timone del leggendario vigneto dal 1789. I figli di Keller, Max e Felix (appena otto
                        e sei anni) sarà senza dubbio il prossimo. Con sede nel Rheinhessen, Keller ne produce alcuni
                        dei vini pregiati più completi della Germania; i suoi Riesling sono fatti a immagine del loro creatore; Asciutto,
                        nobile e dolce. Un produttore nascosto da oltre due secoli, il padre di Klaus-Peter, Klaus
                        ha iniziato ad alzare il livello del vino della sua famiglia negli anni '80. Ha guadagnato una reputazione per aver fatto alto
                        classificando i Riesling, ribaltando gli anni della vinificazione tradizionale e diventando rapidamente
                        il viticoltore più pregiato della regione. Klaus-Peter segue le orme di suo padre “se tu
                        vuoi produrre del buon vino”, dice, “devi sapere cos'è il buon vino”.
                    </div>

                    <div class="howto-title2">Chiamato "i Montrachet tedeschi" da Janice Robinson</div>
                    <div class="howto-text">
                        Nessuno parlando della cantina poteva omettere di citare la cuvée G-Max di vitigni antichi. Regnante come
                        il Riesling secco più costoso del mondo, il vino ottiene lo stesso plauso della critica e del buon vino
                        allo stesso modo gli investitori. Così protettivo nei confronti del vino, Keller non ne rivelerà la fonte, temendo che il
                        l'uva potrebbe essere rubata. E se suona un po' troppo, è perché è proprio così
                        in realtà è già successo. Ambito, raro e di gran lunga il migliore di tutti, G-Max Riesling è
                        quasi un vino virtuale - se ne produce così poco ed è spesso esaurito. Dovrai scavare
                        profondo per una bottiglia di questo: con una media di circa 3.000 € a bottiglia (indipendentemente dall'annata), può
                        certo, ma non è economico.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Il Westhofener Morstein Goldkapsel Riesling Trockenbeerenauslese 2013 ha ricevuto il 19.5 di Jancis Robinson. Periodo di consumo consigliato: dal 2020 al 2060.
                            </li>
                            <li>2014 Westhofener Morstein Spatburgunder Grosse Gewachs nominato uno dei migliori del Rheinhessen
                                Pinot Nero in "The Rise of German Noir" di FT Magazine (settembre 2017).
                            </li>
                            <li>Alla fine del 2017, Keller ha colto l'opportunità di rilevare l'affitto di un minuscolo pezzo di
                                grand cru ripidi pendii a ovest di Piesport - nientemeno che il famoso Schubertslay
                                vigneto, producendo la loro prima annata nel 2018. Dopo il suo imbottigliamento nell'aprile 2019,
                                John Gilman di View From the Cellar osserva 98/100 “L'attesa è già finita
                                grafici e varrà la pena fare qualche organizzazione extra e anticipata per cercare di individuare a
                                poche bottiglie.”
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Klaus-Peter Keller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Die völlige Wiederbelebung der deutschen Weinindustrie ist vielleicht auf einige wenige zurückzuführen
                        Produzenten. Doch Klaus-Peter Keller, der 2001 das Weingut seiner Familie übernahm, war mehr
                        einflussreicher als die meisten anderen.
                    </div>

                    <div class="howto-title2">Wie der Vater, so der Sohn</div>
                    <div class="howto-text">
                        Klaus-Peter ist kein Unbekannter auf den Feldern und nur der letzte in einer langen Reihe männlicher Kellers, die es getan haben
                        stehen seit 1789 an der Spitze des legendären Weinguts. Kellers Söhne Max und Felix (erst acht Jahre alt).
                        und sechs Jahre alt) wird zweifellos der nächste sein. Mit Sitz in Rheinhessen produziert Keller einige
                        einer der vollständigsten edlen Weine Deutschlands; seine Rieslinge sind nach dem Vorbild ihres Herstellers hergestellt; trocken,
                        edel und süß. Klaus-Peters Vater Klaus ist seit über zwei Jahrhunderten ein unbeachteter Produzent
                        begann in den 1980er Jahren, die Messlatte für den Wein seiner Familie höher zu legen. Er erlangte den Ruf, High zu machen
                        Ranglisten-Rieslinge, die die Jahre der traditionellen Weinherstellung auf den Kopf stellten und sich schnell entwickelten
                        der renommierteste Winzer der Region. Klaus-Peter tritt in die Fußstapfen seines Vaters „wenn du
                        „Wer guten Wein produzieren will“, sagt er, „muss wissen, worum es bei gutem Wein geht.“
                    </div>

                    <div class="howto-title2">Von Janice Robinson „die deutschen Montrachets“ genannt</div>
                    <div class="howto-text">
                        Wenn man über das Weingut spricht, kommt man nicht umhin, die Cuvée G-Max aus alten Reben zu erwähnen. Regierend als
                        Der Wein ist der teuerste trockene Riesling der Welt und wird von Kritikern gleichermaßen gelobt wie von erlesenen Weinen
                        Anleger gleichermaßen. Keller schützt den Wein so sehr, dass er seine Herkunft nicht preisgibt, da er befürchtet, dass dies der Fall sein könnte
                        Trauben könnten gestohlen werden. Und wenn das ein bisschen viel klingt, dann deshalb, weil es genau das ist
                        ist eigentlich schon passiert. Der G-Max Riesling ist begehrt, selten und mit Abstand der Beste von allen
                        fast ein virtueller Wein – so wenig wird davon hergestellt und er ist oft ausverkauft. Sie müssen graben
                        Tief für eine Flasche davon: Durchschnittlich rund 3.000 € pro Flasche (unabhängig vom Jahrgang) kann es sein
                        Sicher, aber es ist nicht billig.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Die Westhofener Morstein Goldkapsel Riesling Trockenbeerenauslese 2013 erhielt die Note 19,5 von Jancis Robinson. Empfohlenes Trinkfenster: 2020 bis 2060.
                            </li>
                            <li>Der Westhofener Morstein Spatburgunder Großes Gewächs 2014 wurde zu einem der besten Weine Rheinhessens gekürt
                                Pinot Noirs in „The Rise of German Noir“ des FT Magazine (September 2017).
                            </li>
                            <li>Ende 2017 nutzte Keller die Gelegenheit, um die Pacht eines winzigen Grundstücks zu übernehmen
                                Grand-Cru-Steilhänge westlich von Piesport – kein Geringerer als der berühmte Schubertslay
                                Weinberg, der 2018 seinen ersten Jahrgang produzierte. Nach der Abfüllung im April 2019,
                                John Gilman von „View From the Cellar“ notiert 98/100: „Die Vorfreude ist bereits verflogen
                                Diagramme und es wird sich lohnen, einige zusätzliche und frühzeitige Organisation zu betreiben, um zu versuchen, eine zu finden
                                ein paar Flaschen.“
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Klaus-Peter Keller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        La renaissance complète de l'industrie allemande des vins fins peut, peut-être, être attribuée à une poignée de
                        producteurs. Mais Klaus-Peter Keller, qui a repris le domaine viticole familial en 2001, a été plus
                        influent que la plupart.
                    </div>

                    <div class="howto-title2">Tel père, tel fils</div>
                    <div class="howto-text">
                        Pas étranger aux champs, Klaus-Peter n'est que le dernier d'une longue lignée d'hommes Keller qui ont
                        à la tête du vignoble légendaire depuis 1789. Les fils de Keller, Max et Félix (seulement huit
                        et six ans) sera sans aucun doute le prochain. Basé dans la Hesse rhénane, Keller produit des
                        des vins fins les plus complets d'Allemagne; ses Rieslings sont fabriqués à l'image de leur créateur ; sec,
                        noble et doux. Producteur discret depuis plus de deux siècles, le père de Klaus-Peter, Klaus
                        a commencé à élever la barre du vin de sa famille dans les années 1980. Il a acquis la réputation de faire de la haute
                        classant les Rieslings, bousculant les années de vinification traditionnelle et devenant rapidement
                        le vigneron le plus prisé de la région. Klaus-Peter suit les traces de son père « si vous
                        veulent produire du bon vin », dit-il, « il faut savoir ce qu'est le bon vin ».
                    </div>

                    <div class="howto-title2">Nommé "les Montrachets allemands" par Janice Robinson</div>
                    <div class="howto-text">
                        Lorsqu'on parle du domaine, personne ne peut omettre de mentionner la cuvée de vieilles vignes G-Max. Régnant comme
                        le Riesling sec le plus cher du monde, le vin remporte autant d'éloges de la critique que du bon vin
                        investisseurs. Si protecteur du vin, Keller ne révélera pas sa source, craignant que le
                        les raisins pourraient être volés. Et si cela sonne un peu trop, c'est parce que c'est exactement ce qui a
                        en fait déjà arrivé. Convoité, rare et de loin le meilleur de tous, G-Max Riesling est
                        presque un vin virtuel - il est si peu produit et il est souvent en rupture de stock. va falloir creuser
                        profonde pour une bouteille de ceci : autour de 3 000 € en moyenne la bouteille (quel que soit le millésime), elle peut
                        chose sûre, mais ce n'est pas bon marché.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>2013 Westhofener Morstein Goldkapsel Riesling Trockenbeerenauslese a reçu la note de 19,5 de Jancis Robinson. Fenêtre de consommation recommandée : 2020 à 2060.
                            </li>
                            <li>2014 Westhofener Morstein Spatburgunder Grosse Gewachs nommé l'un des meilleurs de Rheinhessen
                                Pinot Noirs dans « The Rise of German Noir » de FT Magazine (septembre 2017).
                            </li>
                            <li>Fin 2017, Keller a saisi l'opportunité de reprendre le bail d'un petit morceau de
                                les pentes abruptes du grand cru à l'ouest de Piesport - nul autre que le célèbre Schubertslay
                                vignoble, produisant leur premier millésime en 2018. Suite à sa mise en bouteille en avril 2019,
                                View From the Cellar's John Gilman note 98/100 "L'anticipation est déjà hors du
                                graphiques et cela vaudra la peine de faire une organisation supplémentaire et précoce pour essayer de localiser un
                                quelques bouteilles.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Klaus-Peter Keller</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        The complete revival of Germany’s fine wine industry can, perhaps, be attributed to a handful of
                        producers. But Klaus-Peter Keller, who took over his family’s winery in 2001, has been more
                        influential than most.
                    </div>

                    <div class="howto-title2">Like father, like son</div>
                    <div class="howto-text">
                        No stranger to the fields, Klaus-Peter is just the last in a long line of male Kellers who have
                        been at the helm of the legendary vineyard since 1789. Keller’s sons, Max and Felix (just eight
                        and six years old) will undoubtedly be the next. Based in the Rheinhessen, Keller produces some
                        of Germany’s most complete fine wines; his Rieslings are made in the image of their maker; dry,
                        noble and sweet. An under-the-radar producer for over two centuries, Klaus-Peter’s father Klaus
                        began raising the bar on his family’s wine in the 1980s. He gained a reputation for making high
                        ranking Rieslings, turning the years of traditional winemaking on its head and rapidly became
                        the most prized winemaker in the region. Klaus-Peter follows in his father’s footsteps “if you
                        want to produce fine wine”, he says, “you have to know what fine wine is about”.
                    </div>

                    <div class="howto-title2">Named “the German Montrachets” by Janice Robinson</div>
                    <div class="howto-text">
                        No one when talking about the winery could omit to mention the old-vine cuvée G-Max. Reigning as
                        the world’s most expensive dry Riesling, the wine wins equal acclaim from critics and fine wine
                        investors alike. So protective of the wine, Keller will not reveal its source, fearing that the
                        grapes could be stolen. And if that sounds a bit much, it is because it is exactly that has
                        actually already happened. Coveted, rare and by far the finest of them all, G-Max Riesling is
                        almost a virtual wine – so little of it is made and it is often out of stock. You’ll need to dig
                        deep for a bottle of this: averaging around €3,000 a bottle (regardless of vintage), it may a
                        sure thing, but it’s not cheap.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>2013 Westhofener Morstein Goldkapsel Riesling Trockenbeerenauslese received Jancis Robinson’s 19.5. Recommended drinking window: 2020 to 2060.
                            </li>
                            <li>2014 Westhofener Morstein Spatburgunder Grosse Gewachs named one of Rheinhessen’s top
                                Pinot Noirs in FT Magazine’s’ “The Rise of German Noir” (September 2017).
                            </li>
                            <li>In late 2017, Keller seized the opportunity to take over the lease of one tiny piece of
                                grand cru steep-slopes west of Piesport - none other than the famed Schubertslay
                                vineyard, producing their first vintage in 2018. Following its bottling in April 2019,
                                View From the Cellar’s John Gilman notes 98/100 “The anticipation is already off the
                                charts and it will be worth doing some extra and early Organisation to try and locate a
                                few bottles.”
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "KlausPeterKeller",
    data() {
        return {
            select: {report: 'Klaus-Peter Keller', src: '/wine-guide/germany/rheinhessen/klaus-peter-keller'},
            items: [
                {report: 'Klaus-Peter Keller', src: '/wine-guide/germany/rheinhessen/klaus-peter-keller'},
                {report: 'Von Buhl', src: '/wine-guide/germany/rheinhessen/von-buhl'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Klaus-Peter Keller | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Klaus-Peter Keller is a German wine producer from the Rheinhessen region, known for producing high-quality Riesling wines. Enjoy fine wines with Klaus-Peter Keller.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
